import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, FormsModule } from '@angular/forms';
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { RegexSearchModalComponent } from 'src/app/regex-search-modal/regex-search-modal.component';
import { interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

@Component({
  selector: 'app-attribute-interval-count-cap',
  templateUrl: './attribute-interval-count-cap.component.html',
  styleUrls: ['./attribute-interval-count-cap.component.scss'],
})
export class AttributeIntervalCountCapComponent {
  @Input() attrIntervalCountCap: any;
  periods: any;
  inclusionValues: any;
  faTimes = faTimes;
  faPlus = faPlus;
  @Output() public inputChangeEmitter: EventEmitter<any> = new EventEmitter(true);
  debouncer: Subject<string> = new Subject<string>();
  @ViewChild(RegexSearchModalComponent) regexSearchModalComponent: RegexSearchModalComponent;

  constructor(
    private router: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private formsModule: FormsModule,
    private modalHelper: NgbModal
  ) {
    this.debouncer.pipe(debounce(() => interval(1000))).subscribe((value) => this.inputChangeEmitter.emit(value));
  }

  regexSearchModal(
    searchFor: string,
    item: any,
    size: string,
    limitToOne: boolean,
    setValue: boolean,
    itemIndex: number
  ): void {
    this.openRegexSearchModal(searchFor, item, size, limitToOne, setValue, itemIndex);
  }

  openRegexSearchModal(
    searchFor: string,
    item: any,
    size: string,
    limitToOne: boolean,
    setValue: boolean,
    itemIndex: number
  ): void {
    const instance = this.modalHelper.open(RegexSearchModalComponent);
    instance.componentInstance.searchFor = searchFor;
    instance.componentInstance.item = item;
    instance.componentInstance.size = size;
    instance.componentInstance.limitToOne = limitToOne;
    instance.componentInstance.setValue = setValue;
    instance.componentInstance.itemIndex = itemIndex;
    instance.componentInstance.successEvent.subscribe((text: any) => {
      console.log(text);
      console.log(item);
      this.attrIntervalCountCap[itemIndex][item.name] = text;
      this.updateCaps();
      instance.close();
    });
  }

  initCapObject(): void {
    console.log(this.attrIntervalCountCap);
    var tmpObj = {
      class:
        'com.chiprewards.cheetah.business.rules.config.behavior.v2.BehaviorConfiguration$Schedules$Caps$AttrIntervalCountCap',
    };
    if (this.attrIntervalCountCap) {
      this.attrIntervalCountCap.push(tmpObj);
    } else {
      this.attrIntervalCountCap = [];
      this.attrIntervalCountCap.push(tmpObj);
    }
  }

  updateCaps() {
    this.debouncer.next(this.attrIntervalCountCap);
  }

  removeCap(cap: any) {
    this.attrIntervalCountCap.splice(this.attrIntervalCountCap.indexOf(cap), 1);
    this.updateCaps();
  }
}
